import { render, staticRenderFns } from "./BonusPointsChip.vue?vue&type=template&id=3288b02e&scoped=true&"
import script from "./BonusPointsChip.vue?vue&type=script&lang=js&"
export * from "./BonusPointsChip.vue?vue&type=script&lang=js&"
import style0 from "./BonusPointsChip.vue?vue&type=style&index=0&id=3288b02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288b02e",
  null
  
)

export default component.exports